import { useContext } from 'react';
import { EsigningSignatoriesFormFieldContext } from '.';
export function useEsigningSignatoriesFormField() {
    const context = useContext(EsigningSignatoriesFormFieldContext);
    if (!context) {
        throw new Error('useEsigningSignatoriesFormField must be used as a child to <SignatoriesFormFieldProvider>');
    }
    return context;
}
